/* b2s-cart-fix.js — dynamic ATC: correct variant (Snorekit vs size) + Recharge subscription (selling_plan)
   DRAFT THEME ONLY. Reversible (remove the script include + delete asset).
   Strategy: a capture-phase 'submit' listener on the product cart form runs BEFORE the native
   ProductForm.onSubmitHandler. It rewrites input[name=id] to the truly selected variant and injects/removes
   a hidden input[name=selling_plan]. The native handler then does FormData(form) -> /cart/add -> cart drawer. */
(function () {
  'use strict';

  var SNOREKIT = 41431169499319;                       // starter-kit "Snorekit" (one-time)
  var SNOREKIT_HANDLE = 'back2sleep-starter-kit';      // its product handle (root-relative .js fetch = locale-safe)
  var SNOREKIT_PRICE = null;                            // real Snorekit price in cents — fetched live, never hardcoded
  var SIZE = { S: 41431140794551, M: 41431140827319, L: 41431140860087, XL: 41431140892855 }; // nasal-stent
  var PLAN = { monthly: 694337306971, yearly: 694337339739 }; // Recharge selling plans (onetime = none)
  var CHOOSE = 'rdqCtM';   // "Choose My Size" qty-break block id fragment
  var SNORE = 'd9qNcH';    // "Snorekit" qty-break block id fragment
  var SIZE_PRODUCT = 'nasal-stent-back2sleep';

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(cents) { return (Number(cents) / 100).toFixed(2).replace('.', ',') + '€'; }

  /* ---------- i18n: strings come from locale keys injected by Liquid (window.B2S_I18N.cart) so the translation plugin handles every language — English fallback below is the SOURCE language, not a hardcoded translation ---------- */
  var T = (window.B2S_I18N && window.B2S_I18N.cart) || { onetime: 'One-time purchase', onetime_sub: 'Single delivery', monthly: 'Monthly subscription', monthly_sub: 'Free shipping · cancel anytime', yearly: 'Annual plan', yearly_sub: 'Best price per box · billed yearly', pick_plan: 'Choose your plan', tax: 'Tax included', ship: 'Shipping cost will be added at checkout', fee: 'France: €5', free_shipping: 'Free shipping', save: 'Save', pick_first: 'Please choose a size first.', ship_snorekit: 'Free shipping in continental Europe · shipping fees apply to other countries' };

  /* ---------- dynamic pricing from the storefront product JSON (real Recharge prices) ---------- */
  var PRICING = null; // { S:{onetime, monthly, yearly}, ... }
  var PLAN_QTY = { onetime: 1, monthly: 1, yearly: 1 }; // synced from Recharge "Product Quantity" (yearly = 12 boxes shipped & billed once a year)
  function loadPricing() {
    return fetch('/products/' + SIZE_PRODUCT + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var map = {};
        (p.variants || []).forEach(function (v) {
          var size = (v.option1 || v.title || '').trim().toUpperCase();
          if (!SIZE[size]) return;
          var entry = { onetime: v.price, monthly: null, yearly: null };
          (v.selling_plan_allocations || []).forEach(function (a) {
            // show the PER-BOX price: for a prepaid multi-delivery plan (e.g. annual 285€/yr for 12 boxes)
            // a.price is the full upfront charge, so we use per_delivery_price (23,75€/box). The two are
            // identical for today's pay-as-you-go plans, so this is a no-op now and correct after the switch.
            var perBox = (a.per_delivery_price != null ? a.per_delivery_price : a.price);
            if (Number(a.selling_plan_id) === PLAN.monthly) entry.monthly = perBox;
            if (Number(a.selling_plan_id) === PLAN.yearly) entry.yearly = perBox;
          });
          map[size] = entry;
        });
        PRICING = map;
        // sync billed quantity per plan from Recharge ("12 products every 12 months" -> 12)
        (p.selling_plan_groups || []).forEach(function (g) {
          (g.selling_plans || []).forEach(function (s) {
            var q = 1; (s.options || []).forEach(function (o) { if (/quantity/i.test(o.name)) { var n = parseInt(o.value, 10); if (n > 0) q = n; } });
            if (Number(s.id) === PLAN.monthly) PLAN_QTY.monthly = q;
            if (Number(s.id) === PLAN.yearly) PLAN_QTY.yearly = q;
          });
        });
        return map;
      })
      .catch(function () { PRICING = null; });
  }

  /* ---------- read current selection dynamically ---------- */
  // Authoritative: the Choose-My-Size (rdqCtM) radio's checked state. Only fall back to the
  // size-card state if that radio is absent from the DOM (never trust a stale size card otherwise).
  function chooseActive() {
    var cr = $('[id*="' + CHOOSE + '"] input[type="radio"]');
    if (cr) return !!cr.checked;
    var sr = $('[id*="' + SNORE + '"] input[type="radio"]');
    if (sr && sr.checked) return false;
    return !!$('.b2s-size-card.is-selected');
  }
  function selectedSize() { var c = $('.b2s-size-card.is-selected'); return c ? c.dataset.size : null; }
  function selectedPlan() {
    var p = $('.b2s-sub-option.is-selected:not(.b2s-hidden)');
    return p ? p.dataset.plan : 'onetime';
  }

  function currentSelection() {
    if (chooseActive()) {
      var sz = selectedSize();
      if (!sz) return { error: 'size' };
      var sel = { id: SIZE[sz], size: sz, kind: 'size', plan: selectedPlan() };
      // attach the Recharge plan whenever a subscription plan is the active choice.
      // (Unavailable plans are hidden in the UI, so a hidden plan can never be the selected one.)
      if (sel.plan && sel.plan !== 'onetime' && PLAN[sel.plan]) sel.selling_plan = PLAN[sel.plan];
      sel.quantity = PLAN_QTY[sel.plan] || 1; // yearly = 12 boxes shipped & billed once
      return sel;
    }
    return { id: SNOREKIT, kind: 'snorekit', plan: 'onetime' };
  }

  /* ---------- live Snorekit price (cents) — fetched from its own product, never hardcoded ---------- */
  function loadSnorekitPrice() {
    return fetch('/products/' + SNOREKIT_HANDLE + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        var sv = p.variants.filter(function (v) { return Number(v.id) === SNOREKIT; })[0] || p.variants[0];
        if (sv && sv.price != null) {
          SNOREKIT_PRICE = sv.price; window.B2S_SNOREKIT_PRICE = sv.price;
          try { window.dispatchEvent(new CustomEvent('b2s:price-ready')); } catch (e) {}
        }
      })
      .catch(function () {});
  }

  // Formatted price of whatever is currently selected (Snorekit 44,90€ vs size+plan) — the sticky bar reads this.
  function currentPriceFormatted() {
    try {
      var sel = currentSelection();
      if (sel.kind === 'snorekit') return SNOREKIT_PRICE != null ? money(SNOREKIT_PRICE) : null;
      if (sel.kind === 'size') {
        var pr = priceFor(sel.size, sel.plan);
        if (pr != null) return money(pr * (PLAN_QTY[sel.plan] || 1));
      }
    } catch (e) {}
    return null;
  }
  window.B2S_currentPrice = currentPriceFormatted;

  /* ---------- subscription selector UI (dynamic, under the size cards) ---------- */
  var PLAN_LABELS = [
    { key: 'onetime', name: T.onetime, sub: T.onetime_sub },
    { key: 'monthly', name: T.monthly, sub: T.monthly_sub },
    { key: 'yearly', name: T.yearly, sub: T.yearly_sub }
  ];

  // premium tax/shipping reassurance note shown under the subscription options
  var ICON_TAX = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3 5 5.5v5.2c0 4.3 3 7 7 8 4-1 7-3.7 7-8V5.5L12 3Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="m9 12 2.2 2.2L15.5 10" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_SHIP = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 6.5h10.5v8H3V6.5Zm10.5 2.5h3.8l2.7 2.8v2.7h-6.5V9Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="7" cy="16.6" r="1.7" stroke="currentColor" stroke-width="1.6"/><circle cx="16.7" cy="16.6" r="1.7" stroke="currentColor" stroke-width="1.6"/></svg>';

  // reusable premium tax/shipping note (used under BOTH the subscription block and the Snorekit block)
  function noteHTML(extraClass) {
    return '<div class="b2s-note' + (extraClass ? ' ' + extraClass : '') + '">' +
      '<span class="b2s-note-item"><span class="b2s-note-ic">' + ICON_TAX + '</span><span class="b2s-note-tx">' + T.tax + '</span></span>' +
      '<span class="b2s-note-item"><span class="b2s-note-ic">' + ICON_SHIP + '</span><span class="b2s-note-tx">' + T.ship + '</span><span class="b2s-note-pill">' + T.fee + '</span></span>' +
      '</div>';
  }
  // Snorekit ships FREE in continental EU (fees apply only outside) — its OWN coherent note, not the per-size one
  function snorekitNoteHTML(extraClass) {
    return '<div class="b2s-note' + (extraClass ? ' ' + extraClass : '') + '">' +
      '<span class="b2s-note-item"><span class="b2s-note-ic">' + ICON_TAX + '</span><span class="b2s-note-tx">' + T.tax + '</span></span>' +
      '<span class="b2s-note-item"><span class="b2s-note-ic">' + ICON_SHIP + '</span><span class="b2s-note-tx">' + T.ship_snorekit + '</span></span>' +
      '</div>';
  }
  function ensureSnorekitNote() {
    var blk = $('[id*="' + SNORE + '"]') || $('[class*="' + SNORE + '"]');
    if (!blk || $('.b2s-note--snore', blk)) return;
    var holder = document.createElement('div');
    holder.innerHTML = snorekitNoteHTML('b2s-note--snore');
    blk.appendChild(holder.firstChild);
  }

  function injectStyles() {
    if ($('#b2s-cart-fix-style')) return;
    var st = document.createElement('style');
    st.id = 'b2s-cart-fix-style';
    st.textContent =
      /* default HIDDEN: syncSubVisibility is the only thing that reveals it (fail-safe on Snorekit) */
      '.b2s-sub{margin-top:16px;display:none;flex-direction:column;gap:10px}' +
      /* cream label (the Choose-My-Size block has a DARK navy background, like the size-card label) */
      '.b2s-sub__label{font-size:12px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:#f4ecdb;opacity:.85;margin-bottom:2px}' +
      /* unselected card: white bg, navy text (forced over theme button styles) */
      '.b2s-sub .b2s-sub-option{display:flex!important;align-items:center;gap:12px;width:100%;padding:13px 16px;border-radius:12px;border:2px solid rgba(28,37,64,.12)!important;background:#fff!important;color:#1c2540!important;-webkit-text-fill-color:#1c2540!important;cursor:pointer;font-family:inherit;transition:all .2s ease;text-align:left;box-shadow:none!important}' +
      '.b2s-sub .b2s-sub-option.b2s-hidden{display:none!important}' +
      '.b2s-sub .b2s-sub-option:hover{border-color:rgba(28,37,64,.35)!important;transform:translateY(-1px)}' +
      '.b2s-sub .b2s-sub-option *:not(.b2s-sub-save){color:inherit!important;-webkit-text-fill-color:inherit!important}' +
      /* selected card: navy bg, cream text (forced on the button AND every child) */
      '.b2s-sub .b2s-sub-option.is-selected{background:#1c2540!important;color:#f4ecdb!important;-webkit-text-fill-color:#f4ecdb!important;border-color:#1c2540!important;box-shadow:0 14px 28px -12px rgba(28,37,64,.45)!important}' +
      '.b2s-sub-radio{width:18px;height:18px;border-radius:50%;border:2px solid rgba(28,37,64,.35);flex:0 0 auto;position:relative;transition:all .2s}' +
      '.b2s-sub-option.is-selected .b2s-sub-radio{border-color:#f4ecdb}' +
      '.b2s-sub-option.is-selected .b2s-sub-radio:after{content:"";position:absolute;top:3px;left:3px;right:3px;bottom:3px;border-radius:50%;background:#f4ecdb}' +
      '.b2s-sub-body{flex:1 1 auto;min-width:0;display:flex;flex-direction:column}' +
      '.b2s-sub-name{font-weight:700;font-size:14px;line-height:1.2}' +
      '.b2s-sub-sub{font-size:11.5px;opacity:.72;margin-top:2px;font-weight:500}' +
      '.b2s-sub-right{display:flex;flex-direction:column;align-items:flex-end;gap:3px;flex:0 0 auto}' +
      '.b2s-sub-price{font-weight:700;font-size:15px;white-space:nowrap}' +
      /* savings badge: higher specificity (0,3,0) so it keeps its own green over the universal inherit rule */
      '.b2s-sub .b2s-sub-option .b2s-sub-save{font-size:10.5px;font-weight:700;color:#13421b!important;-webkit-text-fill-color:#13421b!important;background:#bfe9c8!important;border-radius:20px;padding:2px 8px;letter-spacing:.02em;white-space:nowrap}' +
      '.b2s-size-hint{margin-top:10px;font-size:13px;color:#c0392b;font-weight:600;display:none}' +
      '.b2s-size-hint.show{display:block}' +
      /* our selector replaces the empty native Recharge widget */
      '.recharge-subscription-widget{display:none!important}' +
      /* hide the native top product price — it is already shown in the Snorekit/size widgets below */
      '.product__info-container .product-savings-price{display:none!important}' +
      /* hide the Lumin qty-break PRICE total inside the Choose-My-Size block: it is bound to the
         starter-kit variant (39€) and rendered a bogus 28,10€ (its fixed_price). Our .b2s-sub shows the
         real size price (34€) dynamically. The Snorekit block (d9qNcH) keeps its correct native total. */
      '[id*="rdqCtM"] .lumin-product-block-qty-break-total,[class*="rdqCtM"] .lumin-product-block-qty-break-total{display:none!important}' +
      /* premium tax/shipping reassurance note — self-contained white card: reads perfectly on the dark
         navy size block (consistent with the white plan cards) AND on the light Snorekit area */
      '.b2s-note{display:flex;flex-direction:column;gap:9px;margin-top:14px;padding:13px 15px;background:#fff;border:1px solid rgba(28,37,64,.1);border-radius:14px;box-shadow:0 12px 28px -20px rgba(28,37,64,.55)}' +
      '.b2s-note-item{display:flex;align-items:center;gap:10px;font-size:12.5px;font-weight:600;color:#1c2540!important;-webkit-text-fill-color:#1c2540!important;line-height:1.25;text-align:left}' +
      '.b2s-note-ic{display:inline-flex;align-items:center;justify-content:center;width:25px;height:25px;border-radius:50%;background:#1c2540!important;color:#f4ecdb!important;flex:0 0 auto}' +
      '.b2s-note-ic svg{width:13px;height:13px;display:block;color:#f4ecdb!important}' +
      '.b2s-note-tx{flex:1 1 auto}' +
      '.b2s-note-pill{display:inline-flex;align-items:center;font-size:11px;font-weight:800;color:#13421b!important;-webkit-text-fill-color:#13421b!important;background:#bfe9c8;border-radius:20px;padding:3px 9px;letter-spacing:.02em;white-space:nowrap;flex:0 0 auto}';
    document.head.appendChild(st);
  }

  function priceFor(size, planKey) {
    if (!PRICING || !PRICING[size]) return null;
    var e = PRICING[size];
    if (planKey === 'onetime') return e.onetime;
    return e[planKey];
  }

  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; } // avoid observer churn
  function setHidden(el, hide) { if (el) el.classList.toggle('b2s-hidden', !!hide); }

  function renderSubPrices() {
    var size = selectedSize() || 'M';
    var base = priceFor(size, 'onetime');
    var selectedHidden = false;
    $all('.b2s-sub-option').forEach(function (opt) {
      var key = opt.dataset.plan;
      var pr = priceFor(size, key);            // per box
      var qty = PLAN_QTY[key] || 1;            // yearly = 12 boxes billed once
      // hide a subscription plan that genuinely has no allocation for this size (only when pricing is known)
      var unavailable = (key !== 'onetime') && !!PRICING && pr == null;
      setHidden(opt, unavailable);
      if (unavailable && opt.classList.contains('is-selected')) selectedHidden = true;
      var priceEl = opt.querySelector('.b2s-sub-price');
      var saveEl = opt.querySelector('.b2s-sub-save');
      setText(priceEl, pr != null ? money(pr * qty) : (key === 'onetime' ? money(base || 3400) : ''));
      if (saveEl) {
        // force the badge colors inline (beats the universal inherit rule on the selected card)
        saveEl.style.setProperty('color', '#13421b', 'important');
        saveEl.style.setProperty('-webkit-text-fill-color', '#13421b', 'important');
        saveEl.style.setProperty('background', '#bfe9c8', 'important');
        if (key === 'monthly') {
          // monthly value prop is free shipping (per validated pricing), not a unit discount
          if (saveEl.style.display !== '') saveEl.style.display = '';
          setText(saveEl, T.free_shipping);
        } else if (key === 'yearly' && pr != null && base != null && pr < base) {
          if (saveEl.style.display !== '') saveEl.style.display = '';
          setText(saveEl, T.save + ' ' + Math.round((1 - pr / base) * 100) + '%');
        } else if (saveEl.style.display !== 'none') saveEl.style.display = 'none';
      }
    });
    if (selectedHidden) selectPlan('onetime'); // never leave an unavailable plan selected
  }

  function selectPlan(key) {
    $all('.b2s-sub-option').forEach(function (o) { o.classList.toggle('is-selected', o.dataset.plan === key); });
  }

  // subscription selector is ONLY relevant for the size / Choose-My-Size path, never for Snorekit
  function syncSubVisibility() {
    var active = chooseActive();
    var sub = $('.b2s-sub');
    if (sub) { var d = active ? 'flex' : 'none'; if (sub.style.display !== d) sub.style.display = d; }
    // the size note lives inside .b2s-sub (shown on the size path); the Snorekit note shows on the Snorekit path
    var sn = $('.b2s-note--snore');
    if (sn) { var sd = active ? 'none' : 'flex'; if (sn.style.display !== sd) sn.style.display = sd; }
    if (!active) {
      // enforce mutual exclusivity: no size stays selected when Snorekit is the active choice
      $all('.b2s-size-card.is-selected').forEach(function (c) { c.classList.remove('is-selected'); });
    }
  }

  function injectSubUI() {
    var chooseBlock = $('[class*="' + CHOOSE + '"] .lumin-product-block-qty-break-variants') ||
                      $('[id*="' + CHOOSE + '"] .lumin-product-block-qty-break-variants') ||
                      $('[id*="' + CHOOSE + '"]');
    if (!chooseBlock) return;
    ensureSnorekitNote();
    if ($('.b2s-sub', chooseBlock)) { renderSubPrices(); syncSubVisibility(); return; }
    var wrap = document.createElement('div');
    wrap.className = 'b2s-sub';
    wrap.innerHTML = '<div class="b2s-sub__label">' + T.pick_plan + '</div>' +
      PLAN_LABELS.map(function (p) {
        return '<button type="button" class="b2s-sub-option' + (p.key === 'onetime' ? ' is-selected' : '') + '" data-plan="' + p.key + '">' +
          '<span class="b2s-sub-radio"></span>' +
          '<span class="b2s-sub-body"><span class="b2s-sub-name">' + p.name + '</span><span class="b2s-sub-sub">' + p.sub + '</span></span>' +
          '<span class="b2s-sub-right"><span class="b2s-sub-price"></span><span class="b2s-sub-save" style="display:none"></span></span>' +
          '</button>';
      }).join('') + noteHTML();
    chooseBlock.appendChild(wrap);
    var hint = document.createElement('div');
    hint.className = 'b2s-size-hint';
    hint.textContent = T.pick_first;
    chooseBlock.appendChild(hint);

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.b2s-sub-option');
      if (!btn) return;
      selectPlan(btn.dataset.plan);
    });
    renderSubPrices();
    syncSubVisibility();
  }

  function flashSizeHint(on) {
    var h = $('.b2s-size-hint');
    if (h) { h.textContent = T.pick_first; h.classList.toggle('show', !!on); }
    $all('.b2s-size-card').forEach(function (c) { c.style.boxShadow = on ? '0 0 0 2px #e53935' : ''; });
  }

  // surface a failed /cart/add (sold out, invalid plan, network) so it is never silent
  function showAddError(msg) {
    var wrap = $('.product-form__error-message-wrapper');
    var el = $('.product-form__error-message');
    if (wrap && el) {
      el.textContent = msg;
      wrap.removeAttribute('hidden');
      setTimeout(function () { wrap.setAttribute('hidden', ''); }, 6000);
      return;
    }
    var h = $('.b2s-size-hint');
    if (h) { h.textContent = msg; h.classList.add('show'); setTimeout(function () { h.classList.remove('show'); }, 6000); }
  }

  /* ---------- FULL INTERCEPTION: take over add-to-cart entirely ----------
     The Lumin qty-break injects its own frozen variant ids on submit (adds wrong size + starter-kit).
     So we BLOCK the native/Lumin add and add exactly ONE correct item ourselves, then open the native drawer. */
  var adding = false;

  function cartDrawerEl() { return document.querySelector('cart-drawer'); }

  // open/refresh the native cart drawer. Prefer the sections returned by /cart/add (Dawn pattern);
  // fall back to a section fetch, then to just opening the drawer element.
  function openDrawer(resp) {
    var cartEl = cartDrawerEl();
    if (!cartEl) return;
    if (cartEl.renderContents && resp && resp.sections) {
      try { cartEl.renderContents(resp); return; } catch (e) {}
    }
    var path = window.location.pathname.replace(/\/$/, '') || '';
    fetch(path + '?sections=cart-drawer,cart-icon-bubble', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        try { cartEl.renderContents({ sections: sections }); }
        catch (e) { if (cartEl.open) cartEl.open(); }
      })
      .catch(function () { if (cartEl.classList) cartEl.classList.add('active', 'animate'); });
  }

  function notifyCart(cartData) {
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData })); } catch (e) {}
    try { if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'b2s-cart-fix', cartData: cartData }); } catch (e) {}
  }

  // write the corrected variant id + selling_plan into the native product form
  function patchForm(form, sel) {
    var idInput = form.querySelector('[name=id]');
    if (idInput) {
      idInput.disabled = false;
      idInput.value = String(sel.id);
      idInput.setAttribute('data-selected-id', String(sel.id));
    }
    // defense-in-depth: remove ANY foreign selling_plan control (a subscription must NEVER leak onto a
    // one-time Snorekit/size add). Only our own .b2s-sp input is allowed, managed below.
    $all('input[name="selling_plan"]:not(.b2s-sp), select[name="selling_plan"]', form).forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
    var sp = form.querySelector('input[name="selling_plan"].b2s-sp');
    if (sel.selling_plan) {
      if (!sp) { sp = document.createElement('input'); sp.type = 'hidden'; sp.name = 'selling_plan'; sp.className = 'b2s-sp'; form.appendChild(sp); }
      sp.value = String(sel.selling_plan);
    } else if (sp) {
      sp.parentNode.removeChild(sp);
    }
    // quantity: the yearly plan ships & bills 12 boxes at once. Use the native quantity input if present,
    // otherwise inject a hidden one. One-time/monthly stay at 1.
    var qty = sel.quantity || 1;
    var nativeQ = form.querySelector('input[name="quantity"]:not(.b2s-qty), select[name="quantity"]');
    var myQ = form.querySelector('input[name="quantity"].b2s-qty');
    if (nativeQ) { nativeQ.value = String(qty); if (myQ) myQ.parentNode.removeChild(myQ); }
    else if (qty > 1) { if (!myQ) { myQ = document.createElement('input'); myQ.type = 'hidden'; myQ.name = 'quantity'; myQ.className = 'b2s-qty'; form.appendChild(myQ); } myQ.value = String(qty); }
    else if (myQ) { myQ.parentNode.removeChild(myQ); }
  }

  function handleAdd() {
    if (adding) return;
    var sel = currentSelection();
    if (sel.error === 'size') {
      flashSizeHint(true);
      var cb = $('[id*="' + CHOOSE + '"]'); if (cb) cb.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    flashSizeHint(false);

    // PREFERRED: correct the native product-form and let Dawn's own ProductForm.onSubmitHandler do the
    // add + cart-drawer render. The native render lays out the line items correctly (verified: item height
    // 87 vs 0 when we render the drawer ourselves). We still block the Lumin qty-break handler upstream.
    var pf = document.querySelector('product-form');
    var nativeForm = pf && pf.querySelector ? pf.querySelector('form') : null;
    if (pf && typeof pf.onSubmitHandler === 'function' && nativeForm) {
      adding = true;
      patchForm(nativeForm, sel);
      try { pf.onSubmitHandler({ preventDefault: function () {}, submitter: null }); }
      catch (e) { manualAdd(sel); }
      setTimeout(function () { adding = false; }, 900);
      return;
    }
    // FALLBACK: no native product-form available -> add it ourselves.
    manualAdd(sel);
  }

  function manualAdd(sel) {
    adding = true;
    var cartEl = cartDrawerEl();
    var fd = new FormData();
    fd.append('id', sel.id);
    fd.append('quantity', sel.quantity || 1);
    if (sel.selling_plan) fd.append('selling_plan', sel.selling_plan);
    if (cartEl && cartEl.getSectionsToRender) {
      try {
        fd.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
      } catch (e) {}
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp && resp.status) {
          showAddError(resp.description || resp.message || 'Sorry, this item could not be added to the cart.');
          try { document.dispatchEvent(new CustomEvent('cart:error', { detail: resp })); } catch (e) {}
          return;
        }
        notifyCart(resp);
        if (cartEl && cartEl.classList && cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
        if (cartEl && cartEl.renderContents && resp && resp.sections) { try { cartEl.renderContents(resp); setTimeout(function () { cartEl.classList.remove('is-empty'); }, 60); } catch (e) { openDrawer(resp); } }
        else { openDrawer(resp); }
      })
      .catch(function () {})
      .finally(function () { setTimeout(function () { adding = false; }, 600); });
  }

  // intercept the ATC button click (capture) -> covers native submit AND Lumin click handlers AND sticky synthetic click
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[id^="ProductSubmitButton-"], button[name="add"], .product-form__submit, .lumin-submit');
    if (!btn) return;
    if (btn.closest('cart-drawer')) return; // ignore cart drawer's own buttons
    e.preventDefault();
    e.stopImmediatePropagation();
    handleAdd();
  }, true);

  // fallback: block any direct cart/add form submit (programmatic) and route through us
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handleAdd();
  }, true);

  /* ---------- keep prices/plan in sync with size + qty-break changes ---------- */
  function refreshSubUI() { renderSubPrices(); syncSubVisibility(); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.b2s-size-card') || e.target.closest('lumin-product-qty-break')) { setTimeout(refreshSubUI, 40); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input[type="radio"]')) { setTimeout(refreshSubUI, 40); }
  });

  /* ---------- boot (guarded: this script is injected in <head> with no defer, so body may be null) ---------- */
  function startObserver() {
    if (!document.body) return;
    var obs = new MutationObserver(function () { injectSubUI(); syncSubVisibility(); });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  function boot() {
    injectStyles();
    injectSubUI();
    syncSubVisibility();
    loadPricing().then(function () { injectSubUI(); renderSubPrices(); syncSubVisibility(); });
    loadSnorekitPrice();
    startObserver();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
